import _ from 'lodash'

export default {
  methods: {
    raiseApiErrorMessage(response) {
      if (!this.isApiResponseError(response)) {
        return false
      }
      if (!this.isApiResponseWithErrorMessage(response)) {
        return false
      }

      this.$alertify.error(this.getApiErrorMessage(response))

      return true
    },
    isApiResponseError(response) {
      let error = null

      error = _.get(response, 'response.data.error')
      if (_.isBoolean(error) && error) {
        return error
      }

      error = _.get(response, 'data.error')
      if (_.isBoolean(error) && error) {
        return error
      }

      return false
    },
    isApiResponseWithErrorMessage(response) {
      return !!this.getApiErrorMessage(response)
    },
    getApiErrorMessage(response) {
      return _.first(this.getApiErrorMessages(response))
    },
    getApiErrorMessages(response) {
      let messages = null

      messages = _.get(response, 'response.data.messages')
      if (messages && _.isArray(messages)) {
        return messages
      }

      messages = _.get(response, 'data.messages')
      if (messages && _.isArray(messages)) {
        return messages
      }

      return []
    }
  }
}
